<template>
  <div>
    <div class="form-row">
      <div class="col-12 d-flex align-items-center align-items-sm-start flex-wrap mb-3 flex-column text-center">
        <h5 class="text-blue-ml">Indicação</h5>
        <p v-if="$store.state.user.profile.firstname">{{ $store.state.user.profile.firstname }}, si llegaste a este puesto por recomendación de alguien, por favor, indica quién te recomendó.</p>
      </div>
    </div>

    <FormIndicationEs />
  </div>
</template>

<script>
  import FormIndicationEs from "./FormIndicationEs.vue"

  export default {
    name: 'BoxIndication',

    components: {
      FormIndicationEs
    },

    methods: { },
  }
</script>

<style lang="scss" scoped></style>
